<template>
  <div>
    <!-- Barra Superior Mobile/Tablet -->
    <v-app-bar
        v-if="isMobile"
        app
        color="#023449"
        dark
        elevation="4"
        class="top-bar-mobile"
    >
      <v-app-bar-nav-icon @click="abrirMenu"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-toolbar-title class="d-flex align-center">
        <v-img
            :src="require('@/assets/icons/Gestor_Logo_.svg')"
            max-height="32"
            max-width="140"
            contain
            @click="$route.path !== '/' && $router.push('/')"
            class="cursor-pointer"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Avatar no canto direito -->
      <v-avatar
          :color="cores[posicao]"
          size="36"
          @click="corAvatar"
          class="avatar-hover"
      >
        <span class="white--text font-weight-bold text-body-2">
          {{ iniciaisUsuario }}
        </span>
      </v-avatar>
    </v-app-bar>

    <!-- Menu Lateral -->
    <transition name="slide-menu">
      <v-navigation-drawer
          v-model="drawerOpen"
          ref="menuPrincipal"
          app
          :permanent="!isMobile"
          :temporary="isMobile"
          :mini-variant="menuMini && !isMobile"
          mini-variant-width="72"
          width="350"
          color="#023449"
          dark
          class="elevation-8 drawer-custom"
          :class="{ 'drawer-mobile': isMobile }"
      >
        <!-- Header do Menu -->
        <template v-slot:prepend>
          <v-list-item class="px-4 header-container" :class="{ 'justify-center': menuMini && !isMobile }">
            <v-list-item-content class="py-2 pt-4 pb-0" :class="{ 'text-center': menuMini && !isMobile }">
              <!-- Logo -->
              <v-img
                  :src="(menuMini && !isMobile) ? require('@/assets/icons/Icone_Gestor.svg') : require('@/assets/icons/Gestor_Logo_.svg')"
                  :max-height="40"
                  :max-width="(menuMini && !isMobile) ? 40 : 170"
                  contain
                  class="logo-transition logo-clickable"
                  :class="{ 'mx-auto': menuMini && !isMobile, 'ml-n4': !menuMini || isMobile }"
                  @click="handleLogoClick"
              />

              <!-- Botão Toggle (apenas desktop) -->
              <v-btn
                  v-show="(!menuMini || isMobile) && !isMobile"
                  icon
                  @click="toggleMenu"
                  small
                  class="toggle-btn-overlay"
                  color="white"
              >
                <v-icon size="20">mdi-chevron-left</v-icon>
              </v-btn>

              <!-- Botão Fechar (mobile) -->
              <v-btn
                  v-if="isMobile"
                  icon
                  @click="fecharMenu"
                  small
                  class="toggle-btn-overlay"
                  color="white"
              >
                <v-icon size="20">mdi-close</v-icon>
              </v-btn>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="mx-4 my-2 divider-custom"></v-divider>

          <v-list dense nav class="py-0 menu-list" style="overflow-y: auto; overflow-x: hidden;">
            <!-- Campo de Busca -->
            <div class="px-3 py-1 pb-2" v-if="!menuMini || isMobile">
              <v-text-field
                  v-model="buscaMenu"
                  placeholder="Buscar menu..."
                  dense
                  outlined
                  hide-details
                  clearable
                  color="white"
                  class="search-field"
                  @click:clear="limparBusca"
              >
                <template v-slot:prepend-inner>
                  <v-icon size="20" color="white">mdi-magnify</v-icon>
                </template>
              </v-text-field>
            </div>

            <!-- Botão de busca quando minimizado (apenas desktop) -->
            <div v-else-if="!isMobile">
              <CustomTooltip text="Buscar" :disabled="false" class="pb-2">
                <v-list-item
                    @click.stop="abrirBusca"
                    exact
                    link
                    class="menu-item"
                >
                  <v-list-item-icon class="mr-4">
                    <v-icon size="22">mdi-magnify</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </CustomTooltip>
            </div>
          </v-list>
        </template>

        <!-- Lista de Menus -->
        <v-list dense nav class="py-0 menu-list" :class="{ 'menu-list-mobile': isMobile }" style="overflow-y: auto; overflow-x: hidden;">
          <!-- Mensagem quando não há resultados -->
          <v-list-item v-if="menusFiltrados.length === 0 && menuFixoFiltrado.length === 0 && buscaMenu" class="px-4">
            <v-list-item-content>
              <p class="text-center text-caption white--text mb-0" style="opacity: 0.7;">
                Nenhum item encontrado
              </p>
            </v-list-item-content>
          </v-list-item>

          <!-- Menu Principal -->
          <template v-for="m in menusFiltrados">
            <!-- Menu com Submenu -->
            <template v-if="m.subMenuStatus && m.subMenu.length > 0">
              <CustomTooltip
                  :key="`${m.titulo}-${forceCloseSubmenus}`"
                  :text="m.titulo"
                  :disabled="!menuMini"
              >
                <v-list-group
                    :prepend-icon="m.icon"
                    no-action
                    color="white"
                    class="menu-group"
                    :value="buscaMenu ? true : undefined"
                    @click.native="(menuMini && !isMobile) && toggleMenu()"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <div class="d-flex align-center pr-1">
                        <v-list-item-title class="white--text font-weight-medium text-body-2">
                          <span v-html="highlightText(m.titulo)"></span>
                        </v-list-item-title>
                        <v-chip
                            v-if="isMenuNovo(m.dataCriacao)"
                            x-small
                            color="success"
                            class="ml-1 badge-novo"
                            label
                            :class="{ 'badge-minimized': menuMini && !isMobile }"
                        >
                          NOVO
                        </v-chip>
                      </div>
                    </v-list-item-content>
                  </template>

                  <v-list-item
                      v-for="sm in m.subMenu"
                      :key="sm.to || sm.href"
                      :to="sm.href ? undefined : sm.to"
                      :href="sm.href"
                      :target="sm.href ? '_blank' : undefined"
                      exact
                      link
                      class="submenu-item pl-3"
                      @click="sm.href ? confirmarLinkIntranet($event, sm.href) : null"
                  >
                    <v-list-item-icon class="mr-3 ml-0">
                      <v-icon size="18">{{ sm.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <div class="d-flex align-center pr-1">
                        <v-list-item-title class="text-body-2 font-weight-regular">
                          <span v-html="highlightText(sm.titulo)"></span>
                        </v-list-item-title>
                        <v-chip
                            v-if="isMenuNovo(sm.dataCriacao)"
                            x-small
                            color="success"
                            class="ml-1 badge-novo"
                            label
                        >
                          NOVO
                        </v-chip>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </CustomTooltip>
            </template>

            <!-- Menu Simples -->
            <template v-else>
              <CustomTooltip
                  :key="m.to || m.titulo"
                  :text="m.titulo"
                  :disabled="!menuMini || isMobile"
              >
                <v-list-item
                    :to="m.to"
                    exact
                    link
                    class="menu-item px-2"
                >
                  <v-list-item-icon class="mr-4">
                    <v-icon size="22">{{ m.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <div class="d-flex align-center pr-1">
                      <v-list-item-title class="white--text font-weight-medium text-body-2">
                        <span v-html="highlightText(m.titulo)"></span>
                      </v-list-item-title>
                      <v-chip
                          v-if="isMenuNovo(m.dataCriacao)"
                          x-small
                          color="success"
                          class="ml-1 badge-novo"
                          label
                          :class="{ 'badge-minimized': menuMini && !isMobile }"
                      >
                        NOVO
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </CustomTooltip>
            </template>
          </template>

          <v-divider v-if="menuFixoFiltrado.length > 0" class="my-3 mx-4 divider-custom"></v-divider>

          <!-- Menu Fixo -->
          <CustomTooltip
              v-for="item in menuFixoFiltrado"
              :key="item.to"
              :text="item.titulo"
              :disabled="!menuMini || isMobile"
          >
            <v-list-item
                :to="item.to"
                exact
                link
                class="menu-item px-4"
            >
              <v-list-item-icon class="mr-4">
                <v-icon size="22">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <div class="d-flex align-center pr-1">
                  <v-list-item-title class="white--text font-weight-medium text-body-2">
                    <span v-html="highlightText(item.titulo)"></span>
                  </v-list-item-title>
                  <v-chip
                      v-if="isMenuNovo(item.dataCriacao)"
                      x-small
                      label
                      color="success"
                      class="ml-1 badge-novo"
                      :class="{ 'badge-minimized': menuMini && !isMobile }"
                  >
                    NOVO
                  </v-chip>
                </div>
              </v-list-item-content>
            </v-list-item>
          </CustomTooltip>
        </v-list>

        <!-- Rodapé (Avatar e Botão Sair) -->
        <template v-slot:append>
          <div class="pa-3">
            <!-- Avatar com informações -->
            <div class="d-flex align-center mb-2 user-section" :class="{ 'justify-center': menuMini && !isMobile }">
              <v-avatar
                  :color="cores[posicao]"
                  :size="(menuMini && !isMobile) ? 40 : 36"
                  @click="corAvatar"
                  class="avatar-hover elevation-2"
              >
              <span class="white--text font-weight-bold" :class="(menuMini && !isMobile) ? 'text-body-1' : 'text-body-2'">
                {{ iniciaisUsuario }}
              </span>
              </v-avatar>

              <div v-if="!menuMini || isMobile" class="ml-3 user-info">
                <p class="text-body-2 font-weight-medium white--text mb-0 text-truncate">
                  {{ usuario.nome }}
                </p>
                <p class="text-caption mb-0 text-truncate" style="color: rgba(255,255,255,0.65);">
                  {{ usuario.grupo }}
                </p>
              </div>
            </div>

            <v-divider class="my-2 divider-custom"></v-divider>

            <!-- Botão Sair -->
            <v-btn
                small
                block
                outlined
                color="white"
                @click="$emit('logout')"
                class="logout-btn"
                :height="isMobile ? 38 : 34"
            >
              <v-icon :left="!menuMini || isMobile" size="20">mdi-logout</v-icon>
              <span v-show="!menuMini || isMobile" class="ml-2 font-weight-medium">Sair</span>
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
    </transition>

    <v-dialog v-model="dialogLinkIntranet" max-width="420">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left color="warning">mdi-lan-disconnect</v-icon>
          Acesso restrito à rede interna
        </v-card-title>
        <v-card-text>
          Este link só é acessível por máquinas conectadas à rede interna da empresa. Se você não estiver
          na rede, a página não vai carregar.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogLinkIntranet = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="abrirLinkIntranetConfirmado">Entendi, abrir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomTooltip from "./CustomTooltip.vue";
import menuMixin from "../../util/menuMixin";

export default {
  name: "MenuPrincipal",

  components: {
    CustomTooltip
  },

  mixins: [menuMixin],

  props: {
    value: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: Object,
      required: true
    }
  },

  data: () => {
    // calculado já na primeira leitura de data() (não só depois, em mounted()/checkDevice), pra evitar o
    // menu nascer aberto (padrão desktop) e só fechar um instante depois em telas pequenas — isso chegava a
    // aparecer na tela como um "flash" de menu abrindo e fechando sozinho ao carregar a página no mobile
    const isMobileInicial = window.innerWidth < 960;
    return {
      cores: [
        "accent",
        "red",
        "green",
        "blue",
        "orange",
        "purple",
        "indigo",
        "deep-purple",
      ],
      posicao: 0,
      menuMini: false,
      forceCloseSubmenus: 0,
      buscaMenu: "",
      dialogLinkIntranet: false,
      linkIntranetPendente: null,
      drawerOpen: !isMobileInicial,
      isMobile: isMobileInicial,
      isTablet: window.innerWidth >= 960 && window.innerWidth < 1264
    };
  },

  computed: {
    usuarioValido() {
      return this.usuario && this.usuario.nome;
    },

    iniciaisUsuario() {
      if (!this.usuarioValido) return '?';
      return this.usuario.nome.charAt(0).toUpperCase();
    },

    menusFiltrados() {
      if (!this.buscaMenu || this.buscaMenu.trim() === "") {
        return this.menuPrincipal;
      }

      const termoBusca = this.buscaMenu.toLowerCase().trim();

      return this.menuPrincipal
          .map(menu => {
            const tituloMatch = menu.titulo.toLowerCase().includes(termoBusca);

            if (menu.subMenuStatus && menu.subMenu && menu.subMenu.length > 0) {
              const subMenusFiltrados = menu.subMenu.filter(submenu =>
                  submenu.titulo.toLowerCase().includes(termoBusca)
              );

              if (tituloMatch) {
                return { ...menu, subMenu: menu.subMenu };
              }

              if (subMenusFiltrados.length > 0) {
                return { ...menu, subMenu: subMenusFiltrados };
              }

              return null;
            }

            return tituloMatch ? menu : null;
          })
          .filter(menu => menu !== null);
    },

    menuFixoFiltrado() {
      if (!this.buscaMenu || this.buscaMenu.trim() === "") {
        return this.menuFixoProcessado;
      }

      const termoBusca = this.buscaMenu.toLowerCase().trim();

      return this.menuFixoProcessado.filter(item =>
          item.titulo.toLowerCase().includes(termoBusca)
      );
    }
  },

  methods: {
    confirmarLinkIntranet(event, href) {
      event.preventDefault();
      this.linkIntranetPendente = href;
      this.dialogLinkIntranet = true;
    },

    abrirLinkIntranetConfirmado() {
      if (this.linkIntranetPendente) {
        window.open(this.linkIntranetPendente, '_blank');
      }
      this.dialogLinkIntranet = false;
      this.linkIntranetPendente = null;
    },

    checkDevice() {
      this.isMobile = window.innerWidth < 960;
      this.isTablet = window.innerWidth >= 960 && window.innerWidth < 1264;

      // Em mobile, sempre começa fechado
      if (this.isMobile) {
        this.menuMini = false;
        this.drawerOpen = false;
      }
    },

    abrirMenu() {
      this.drawerOpen = true;
      this.$emit('input', true);
    },

    fecharMenu() {
      this.drawerOpen = false;
      this.$emit('input', false);
    },

    handleLogoClick() {
      // Se menu minimizado no desktop, expande o menu
      if (this.menuMini && !this.isMobile) {
        this.toggleMenu();
      } else {
        // Em outros casos, navega para home
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      }
    },

    toggleMenu() {
      if (this.isMobile) {
        this.fecharMenu();
      } else {
        // Em desktop, minimiza/expande
        this.menuMini = !this.menuMini;
      }
    },

    highlightText(text) {
      if (!this.buscaMenu || this.buscaMenu.trim() === "") {
        return text;
      }

      const termoBusca = this.buscaMenu.trim();
      const regex = new RegExp(`(${termoBusca})`, 'gi');

      return text.replace(regex, '<span class="highlight-search">$1</span>');
    },

    limparBusca() {
      this.buscaMenu = "";
    },

    abrirBusca() {
      this.menuMini = false;

      setTimeout(() => {
        this.$nextTick(() => {
          const searchField = this.$el.querySelector('.search-field input');
          if (searchField) {
            searchField.focus();
          }
        });
      }, 350);
    },

    isMenuNovo(dataCriacao) {
      if (!dataCriacao) return false;

      const hoje = new Date();
      const dataMenu = new Date(dataCriacao);
      const diferencaMs = hoje - dataMenu;
      const diferencaDias = diferencaMs / (1000 * 60 * 60 * 24);

      return diferencaDias <= 90;
    },

    corAvatar() {
      this.posicao = Math.floor(Math.random() * this.cores.length);
    },

    handleClickOutside(event) {
      // Não minimiza em mobile (fecha o drawer ao invés)
      if (this.isMobile) return;

      if (!this.menuMini && this.$refs.menuPrincipal) {
        const menuElement = this.$refs.menuPrincipal.$el;
        if (menuElement && !menuElement.contains(event.target)) {
          if (!this.buscaMenu || this.buscaMenu.trim() === "") {
            this.menuMini = true;
          }
        }
      }
    },

    handleResize() {
      this.checkDevice();
    }
  },

  mounted() {
    this.checkDevice();
    this.carregarMenus();
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', this.handleResize);
    document.body.style.overflow = '';
  },

  watch: {
    value(newVal) {
      this.drawerOpen = newVal;
    },

    drawerOpen(newVal) {
      if (this.isMobile) {
        document.body.style.overflow = newVal ? 'hidden' : '';
        if (!newVal) {
          this.$emit('input', false);
        }
      }
    },

    menuMini(novoValor) {
      if (novoValor) {
        this.forceCloseSubmenus++;
        this.limparBusca();
      }
    },

    buscaMenu(novoValor) {
      if (novoValor && novoValor.trim() !== "") {
        this.forceCloseSubmenus++;
      }
    }
  }
};
</script>

<style scoped>
/* ===================================
   CORREÇÃO DO CONFLITO DE MARGENS
   =================================== */

/* Força margin-right: 0 quando mini-variant está ativo - MAIOR ESPECIFICIDADE */
::v-deep .v-navigation-drawer--mini-variant .v-list-item > .v-list-item__icon:first-child,
::v-deep .v-navigation-drawer--mini-variant .v-list-item > .v-list-item__action:first-child {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Mantém o espaçamento normal quando não está em mini-variant */
::v-deep .v-navigation-drawer:not(.v-navigation-drawer--mini-variant) .v-list-item__icon:first-child,
::v-deep .v-navigation-drawer:not(.v-navigation-drawer--mini-variant) .v-list-item__action:first-child {
  margin-right: 18px !important;
}

/* ===================================
   ESTILOS GERAIS
   =================================== */

/* Barra superior mobile/tablet */
.top-bar-mobile {
  z-index: 8 !important;
}

.top-bar-mobile .v-toolbar__content {
  padding: 0 12px;
}

/* Transição do Menu Lateral */
.slide-menu-enter-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease;
}

.slide-menu-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
}

.slide-menu-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-menu-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.drawer-custom {
  z-index: 7 !important;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15) !important;
}

.drawer-mobile {
  z-index: 250 !important;
}

.drawer-custom >>> .v-navigation-drawer__content {
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}

@media (max-width: 959px) {
  .drawer-custom {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3) !important;
  }

  .drawer-custom >>> .v-navigation-drawer__content {
    padding-top: 8px;
  }
}

.header-container {
  position: relative;
  height: 60px;
}

.header-container .v-list-item__content {
  position: relative;
}

.logo-transition {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.logo-clickable {
  cursor: pointer;
  opacity: 0.9;
}

.logo-clickable:hover {
  opacity: 1;
  transform: scale(1.05);
}

.toggle-btn-overlay {
  position: absolute !important;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
  transition: background-color 0.3s ease;
  z-index: 10;
  margin-top: 4px;
}

.toggle-btn-overlay:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: translateY(-50%) scale(1.1);
}

.search-field >>> .v-input__control {
  min-height: 38px !important;
}

.search-field >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.3s ease;
}

.search-field >>> .v-input__slot:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.search-field.v-input--is-focused >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.18) !important;
  border-color: white !important;
  box-shadow: 0 0 0 1px white !important;
}

.search-field >>> input {
  color: white !important;
  caret-color: white !important;
}

.search-field >>> input::placeholder {
  color: rgba(255, 255, 255, 0.6) !important;
}

.search-field >>> .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-field >>> .v-input__append-inner .v-icon:hover {
  color: white !important;
}

.highlight-search {
  background-color: rgba(255, 235, 59, 0.4);
  padding: 2px 4px;
  border-radius: 3px;
  font-weight: 600;
}

.avatar-hover {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
}

.avatar-hover:hover {
  transform: scale(1.08);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3) !important;
}

.user-section {
  min-height: 40px;
}

.user-info {
  flex: 1;
  min-width: 0;
  line-height: 1.2;
}

.user-info p {
  line-height: 1.3;
}

.divider-custom {
  border-color: rgba(255, 255, 255, 0.12) !important;
  opacity: 1;
}

.menu-list {
  overflow-y: auto;
  max-height: calc(100vh - 260px);
  padding-right: 4px;
}

.menu-list-mobile {
  max-height: calc(100vh - 240px);
}

@media (max-width: 959px) {
  .menu-list {
    -webkit-overflow-scrolling: touch;
  }
}

.menu-item {
  margin: 2px 8px;
  border-radius: 8px !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

@media (max-width: 959px) {
  .menu-item {
    min-height: 48px !important;
  }

  .menu-item >>> .v-list-item__icon {
    margin-right: 16px !important;
  }
}

.submenu-item {
  margin: 0 8px 2px 8px;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.submenu-item:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
  transform: translateX(4px);
}

@media (max-width: 959px) {
  .submenu-item {
    min-height: 44px !important;
  }
}

.v-list-item--active {
  background: linear-gradient(90deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%) !important;
  border-left: 4px solid white !important;
  font-weight: 600 !important;
}

.v-list-item--active::before {
  opacity: 0 !important;
}

.v-list-item--active .v-icon {
  color: white !important;
  transform: scale(1.1);
}

.menu-group {
  margin: 4px 8px;
}

.menu-group .v-list-group__header {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.menu-group .v-list-group__header:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.logout-btn {
  border-width: 2px !important;
  border-radius: 8px !important;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
}

@media (max-width: 959px) {
  .logout-btn {
    font-size: 15px !important;
  }
}

.menu-list::-webkit-scrollbar {
  width: 5px;
}

.menu-list::-webkit-scrollbar-track {
  background: transparent;
}

.menu-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

.menu-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.badge-novo {
  height: 18px !important;
  font-size: 9px !important;
  font-weight: 500 !important;
  letter-spacing: 1px;
  padding: 0 10px 0 6px !important;
  animation: pulse-badge 2s ease-in-out infinite;
}

.badge-minimized {
  display: none !important;
}

@keyframes pulse-badge {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.85;
    transform: scale(1.05);
  }
}

.v-navigation-drawer {
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-navigation-drawer--mini-variant .v-list-group__header {
  padding: 0 12px !important;
  justify-content: center;
}

.v-navigation-drawer--mini-variant .v-list-item {
  justify-content: center;
  padding: 0 12px !important;
}

@media (max-width: 959px) {
  .v-navigation-drawer--mini-variant .v-list-item {
    padding: 0 16px !important;
  }

  .v-navigation-drawer--mini-variant .v-list-item__icon {
    margin-right: 16px !important;
  }

  .top-bar-mobile .v-toolbar-title img {
    max-width: 120px !important;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .drawer-custom:not(.v-navigation-drawer--mini-variant) {
    width: 350px !important;
  }

  .drawer-custom.v-navigation-drawer--mini-variant {
    width: 72px !important;
  }
}
</style>